import { CTASection } from "../components/CTASection";
import { FAQSection } from "../components/FAQSection";
import { FeaturesSection } from "../components/FeaturesSection";
import { HeroSection } from "../components/HeroSection";
import { HowItWorksSection } from "../components/HowItWorksSection";
import { MarketingFooter } from "../components/MarketingFooter";
import { MarketingNavbar } from "../components/MarketingNavbar";
import { PilotProgramSection } from "../components/PilotProgramSection";
import { WhyMinistryIQSection } from "../components/WhyMinistryIQSection";

export function HomePage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <MarketingNavbar />

      <main>
        <HeroSection />
        <FeaturesSection />
        <HowItWorksSection />
        <WhyMinistryIQSection />
        <PilotProgramSection />
        <FAQSection />
        <CTASection />
      </main>

      <MarketingFooter />
    </div>
  );
}
